import {
  Actions,
  Breadcrumbs,
  Flag,
  Parameters,
  type Action,
  type FlagProps,
} from 'platform/components';
import {Box, Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import type {TestIdProps} from 'shared/web';

export type NewVehiclePageHeaderProps = TestIdProps & {
  breadcrumbs: {label: string; href?: string}[];
  title: string;
  subtitle?: string;
  status?: Pick<FlagProps, 'label' | 'colorScheme' | 'isSubtle'>;
  parameters?: string[];
  actions?: Action[];
};

export function NewVehiclePageHeader(props: NewVehiclePageHeaderProps) {
  const breadcrumbs = props.breadcrumbs.map((breadcrumb, index) => ({
    ...breadcrumb,
    isCurrentPage: index === props.breadcrumbs.length - 1,
  }));

  return (
    <Box paddingVertical={2} data-testid={props['data-testid']}>
      <VStack spacing={3}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <HStack justify="space-between" align="center" spacing={4}>
          <VStack spacing={1}>
            <HStack spacing={3} align="center">
              <Heading size={1}>{props.title}</Heading>
              <Show when={props.status}>
                <Flag
                  label={props.status?.label ?? ''}
                  colorScheme={props.status?.colorScheme ?? 'neutral'}
                  isSubtle={props.status?.isSubtle}
                />
              </Show>
            </HStack>
            <Show when={props.subtitle}>
              <Text size="small" color="secondary">
                {props.subtitle}
              </Text>
            </Show>
            <Parameters parameters={props.parameters} size="small" color="secondary" />
          </VStack>
          <Actions actions={props.actions} />
        </HStack>
      </VStack>
    </Box>
  );
}
